module.exports = __webpack_public_path__ + "img/logo.d3da487d.svg";